var _defs, _rect, _path, _rect2, _rect3, _line, _line2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calendar_Icon",
    "data-name": "Calendar Icon",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 91.35 87.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1-calendar{fill:none;}.cls-1-calendar,.cls-2-calendar,.cls-3-calendar{stroke-miterlimit:10;stroke-width:5.1px;}.cls-2-calendar,.cls-3-calendar{}.cls-3-calendar{stroke-linecap:round;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1-calendar",
    x: 3,
    y: 12.7,
    width: 85.35,
    height: 72.17,
    rx: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2-calendar",
    d: "M237.21,174.17h81.45S324.53,154,304.36,154H246.75l-7.69,4-3.32,6.13-.19,10.08Z",
    transform: "translate(-231.75 -141.3)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2-calendar",
    x: 18.49,
    y: 3,
    width: 5.11,
    height: 12.77,
    rx: 2.55
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2-calendar",
    x: 67.26,
    y: 3,
    width: 5.11,
    height: 12.77,
    rx: 2.55
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-3-calendar",
    x1: 15.61,
    y1: 49.34,
    x2: 75.74,
    y2: 49.34
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3-calendar",
    x1: 15.61,
    y1: 65.62,
    x2: 39.55,
    y2: 65.62
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/Calendar.fe2506d1ef989489402557c8f48d742d.svg";
export { ForwardRef as ReactComponent };